// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__wYL2y","card":"Card_card__uFbbj","banner":"Card_banner__ZP45t","pill":"Card_pill__-pY9F","titleWrapper":"Card_titleWrapper__x4WDA","chip":"Card_chip__dQ2oq"};